import {
  Directive,
  EmbeddedViewRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from "@angular/core";
import { MediaScreenService } from "@app/modules/media-screen/media-screen.service";
import { Subscription } from "rxjs";

@Directive({ selector: "[mediaScreenDown]" })
export class MediaScreenDownDirective implements OnDestroy, OnChanges {
  @Input() mediaScreenDown: string;
  private subs = new Subscription();

  private embedded: EmbeddedViewRef<any>;

  constructor(
    private tpl: TemplateRef<any>,
    private vcr: ViewContainerRef,
    private ms: MediaScreenService
  ) {
    this.subs.add(this.ms.current$.subscribe(() => this.update()));
  }

  ngOnChanges({ mediaScreenDown }: SimpleChanges) {
    if (mediaScreenDown) {
      this.update();
    }
  }

  update() {
    if (
      matchMedia(
        `(max-width: ${
          this.ms.getBreakpointSize(this.mediaScreenDown) - 0.1
        }px)`
      ).matches
    ) {
      if (!this.embedded) {
        this.embedded = this.vcr.createEmbeddedView(this.tpl);
      }
    } else if (this.embedded) {
      this.embedded.destroy();
      this.embedded = undefined;
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    if (this.embedded) {
      this.embedded.destroy();
    }
  }
}
